import { app } from '../../../../app';

app.factory('CompanyLoginReportService', CompanyLoginReportService);

/** @ngInject */
function CompanyLoginReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report';

    return {
        companyLoginReport : $resource(rootUrl,{},{ 'initialReport': {
            method: 'POST',
        }}),
        companyLoginReportFilter : $resource(rootUrl+'/filter',{},{ 'doFilter': {
            method: 'POST',
            isArray: true
        }}),

    }
    

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/company-login-report/company-login-report.service.js